import type { ReactNode } from "react";
import { Boton } from "../atoms";
import estilos from "./Estados.module.css";

/** Estado vacío: dice qué falta y qué hacer, nunca un espacio en blanco. */
export function Vacio({
  titulo,
  children,
  accion,
}: {
  readonly titulo: string;
  readonly children?: ReactNode;
  readonly accion?: ReactNode;
}) {
  return (
    <div className={estilos.vacio}>
      <b>{titulo}</b>
      {children}
      {accion && <div className={estilos.accion}>{accion}</div>}
    </div>
  );
}

export type TonoAviso = "alerta" | "grave" | "bien";

/** Aviso destacado a todo el ancho (alertas del embarque, mensajes de un formulario). */
export function Aviso({
  tono = "alerta",
  rol,
  children,
}: {
  readonly tono?: TonoAviso;
  readonly rol?: "status" | "alert";
  readonly children: ReactNode;
}) {
  return (
    <div className={[estilos.aviso, tono !== "alerta" && estilos[tono]].filter(Boolean).join(" ")} role={rol}>
      {children}
    </div>
  );
}

export function Cargando({ texto }: { readonly texto: string }) {
  return (
    <div className={estilos.cargando} role="status" aria-live="polite">
      {texto}
    </div>
  );
}

/** Error al cargar, con la acción de reintentar. */
export function ErrorDeCarga({
  titulo,
  texto,
  textoReintentar,
  alReintentar,
}: {
  readonly titulo: string;
  readonly texto: string;
  readonly textoReintentar: string;
  readonly alReintentar: () => void;
}) {
  return (
    <div role="alert">
      <Vacio titulo={titulo} accion={<Boton onClick={alReintentar}>{textoReintentar}</Boton>}>
        {texto}
      </Vacio>
    </div>
  );
}
